<div class="table-responsive mat-elevation-z8" infinite-scroll [style.height.px]="tableHeight">
  <div class="table-scroll-report table-scroll-report-width">
    <table *ngIf="IsShow" class="table table-layout-fixed">
      <thead class="reportdata fixedheader">
        <tr>
          <th width="100" class="">Date</th>
          <ng-container *ngIf="GraphType=='Daily'">
            <th width="100" class="">Time</th>
          </ng-container>
          <th width="80" *ngFor="let Tag of ReportData.TagList;" class="text-right word-wrap">{{ReportData.header[Tag]}}
          </th>
        </tr>
      </thead>
      <tbody class="table-responsive-sechedule">
        <!-- <tr *ngFor="let devicedata of ReportData.ReportData">
          <td width="100" class="reportdata">{{devicedata.Str_RTC.split(' ')[0]}}</td>
          <ng-container *ngIf="GraphType=='Daily'">
            <td width="80" class="reportdata">{{devicedata.Str_RTC.split(' ')[1]}}</td>
          </ng-container>
          <td width="80" *ngFor="let Tag of ReportData.TagList;" class="text-right reportdata word-wrap">
            {{devicedata[Tag]}}</td>
        </tr> -->

        <!-- <tr *ngFor="let devicedata of ReportData.ReportData">
          <td width="100" class="reportdata">
            {{ devicedata.Str_RTC.split(' ')[0] }}
          </td>
          <ng-container *ngIf="GraphType=='Daily'">
            <td width="80" class="reportdata">{{
              devicedata.Str_RTC.split(' ')[1] }}</td>
          </ng-container>
          <td width="80" *ngFor="let Tag of ReportData.TagList;" class="text-right reportdata word-wrap">
            {{ devicedata[Tag] }}
          </td>
        </tr> -->

        <!-- <tr
          *ngFor="let devicedata of ReportData.ReportData.length>1?ReportData.slice(0, ReportData.ReportData.length - 1):ReportData.ReportData"> -->
        <tr *ngFor="let devicedata of ReportData.ReportData">
          <td width="100" class="reportdata">
            {{ devicedata.Str_RTC.split(' ')[0] }}
          </td>
          <ng-container *ngIf="GraphType=='Daily'">
            <td width="80" class="reportdata">{{
              devicedata.Str_RTC.split(' ')[1] }}</td>
          </ng-container>
          <td width="80" *ngFor="let Tag of ReportData.TagList;" class="text-right reportdata word-wrap">
            {{ devicedata[Tag] }}
          </td>
        </tr>
        <!-- total data display in daily report  -->
        <ng-container>
          <tr *ngFor="let devicedata of ReportData.TotalData">
            <td width="100" class="reportdata" [ngStyle]="{'font-weight':  'bold' , 'color': 'black' }"
              *ngIf="this.totaltagflag==false">
              Total
            </td>
            <ng-container *ngIf="GraphType=='Daily'">
              <td width="80" class="reportdata"> </td>
            </ng-container>
            <td width="80" *ngFor="let Tag of ReportData.TagList;" class="text-right reportdata word-wrap"
              [ngStyle]="{'font-weight':  'bold' , 'color': 'black' }">
              {{ devicedata[Tag] }}
            </td>
          </tr>
        </ng-container>


      </tbody>
    </table>
    <div *ngIf="noDataMsg" class="main-errormsg paddingtop15 textcenter">{{noDataMsg}}</div>
  </div>
</div>